import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Alert, Button, Col, Row, Table, Form } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import { ShimmerTable } from "react-shimmer-effects";
import { ToastContainer, toast } from "react-toastify";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link, useNavigate } from "react-router-dom";
import Confirm from "../Confirm";
import InfoPill from "../InfoPill";
import {
  Editor,
  EditorProvider,

} from "react-simple-wysiwyg";

import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import jwt_decode from "jwt-decode";


const Anouncement = (props) => {
  const navigate = useNavigate();
  const [anndetails, setAnnDetails] = useState({
    title: "",
    description: "",
    media: [],
  });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewFiles, setPreviewFiles] = useState([]);
  const [body, setBody] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isModal, setIsModal] = useState(false);
  const [btnName, setBtnName] = useState("Save");
  let [reportData, setReportData] = useState({
    date: new Date(),
  });

  const [fileDescription, setFileDescription] = useState("");

  const fetchUpdatedAnouncement = async () => {
    try {
      const anouncementData = await schoolApi.getAllAnouncement();
      if (anouncementData.success) {
        setBody(anouncementData.result);
      } else {
        setBody([]);
        toast.error(anouncementData.message);
      }
    } catch (error) {
      return toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    fetchUpdatedAnouncement();
  }, []);


  // const fetchFiles = async (id) => {
  //   try {

  //     sessionStorage.getItem("token");
  //     const user = jwt_decode(sessionStorage.getItem("token"));

  //     console.log('fetchFiles--->', id);
  //     const response = await schoolApi.fetchFiles(id);
  //     console.log('response--on update->', response);


  //     if (response.success) {

  //       response?.result?.forEach(file => {
  //         let path = process.env.NODE_ENV === "development"
  //           ? `http://localhost:4011/uploads/${id}/${file.id}.${file.filetype}`
  //           : `https://${user.tenantcode}.idigischool.com/uploads/${id}/${file.id}.${file.filetype}`;

  //         console.log('path--->', path);

  //         setPreviewFiles(prevFiles => [
  //           ...prevFiles,
  //           {
  //             name: file.title,
  //             type: `image/${file.filetype}`,
  //             url: path
  //           }
  //         ]);
  //       });

  //       setSelectedFiles(response?.result);
  //     }
  //     else {
  //       toast.error(response.message);
  //     }

  //   } catch (error) {
  //     console.log('error--on update->', error);
  //     return toast.error(error?.response?.data?.message);
  //   }

  // }

  // const fetchFiles = async (id) => {
  //   try {
  //     sessionStorage.getItem("token");
  //     const user = jwt_decode(sessionStorage.getItem("token"));
  
  //     console.log('fetchFiles--->', id);
  //     const response = await schoolApi.fetchFiles(id);
  //     console.log('response--on update->', response);
  
  //     if (response.success) {
  //       const updatedFiles = response.result.map(file => {
  //         let path = process.env.NODE_ENV === "development"
  //           ? `http://localhost:4011/uploads/${id}/${file.id}.${file.filetype}`
  //           : `https://${user.tenantcode}.idigischool.com/uploads/${id}/${file.id}.${file.filetype}`;
  
  //         console.log('path--->', path);
  
  //         // Determine correct MIME type based on file extension
  //         let fileType = "";
  //         if (["png", "jpg", "jpeg", "gif"].includes(file.filetype)) {
  //           fileType = `image/${file.filetype}`;
  //         } else if (["mp4", "webm", "ogg"].includes(file.filetype)) {
  //           fileType = `video/${file.filetype}`;
  //         } else if (["pdf"].includes(file.filetype)) {
  //           fileType = "application/pdf";
  //         } else {
  //           fileType = "application/octet-stream"; // Generic for unknown types
  //         }
  
  //         return {
  //           name: file.title,
  //           type: fileType,
  //           url: path
  //         };
  //       });
  
  //       setPreviewFiles(updatedFiles); // Avoid unnecessary spread
  //       setSelectedFiles(response.result);
  //     } else {
  //       toast.error(response.message);
  //     }
  //   } catch (error) {
  //     console.log('error--on update->', error);
  //     return toast.error(error?.response?.data?.message);
  //   }
  // };
  
  const fetchFiles = async (id) => {
    try {
      const token = sessionStorage.getItem("token");
      const user = jwt_decode(token);
  
      console.log("fetchFiles--->", id);
      const response = await schoolApi.fetchFiles(id);
      console.log("response--on update->", response);
  
      if (response.success) {
        const updatedFiles = response.result.map((file) => {
          let path =
            process.env.NODE_ENV === "development"
              ? `http://localhost:4011/uploads/${id}/${file.id}.${file.filetype}`
              : `https://${user.tenantcode}.idigischool.com/uploads/${id}/${file.id}.${file.filetype}`;
  
          console.log("path--->", path);
  
          // Determine correct MIME type based on file extension
          const mimeTypes = {
            png: "image/png",
            jpg: "image/jpeg",
            jpeg: "image/jpeg",
            gif: "image/gif",
            mp4: "video/mp4",
            webm: "video/webm",
            ogg: "video/ogg",
            pdf: "application/pdf",
            doc: "application/msword",
            docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            xls: "application/vnd.ms-excel",
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            csv: "text/csv",
            txt: "text/plain",
          };
  
          const fileType = mimeTypes[file.filetype] || "application/octet-stream";
  
          return {
            name: file.title,
            type: fileType,
            url: path,
          };
        });
  
        setPreviewFiles(updatedFiles); // Avoid unnecessary state spreading
        setSelectedFiles(response.result);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log("error--on update->", error);
      return toast.error(error?.response?.data?.message || "Failed to fetch files.");
    }
  };

  const handleEditButton = (row) => {
    if (row.id) {
      setPreviewFiles([]);
      setSelectedFiles([]);
      fetchFiles(row.id);
    } else {
      reportData.date = null;
    }


    if (row.media && row.media.length > 0) {
      setPreviewFiles(row.media);
      const existingFiles = row.media.map(file => {
        if (file instanceof File) return file;
        return new File([], file.name, { type: file.type });
      });
      setSelectedFiles(existingFiles);
    }

    setAnnDetails(row);
    setIsModal(true);
    setBtnName("Update");
  };

  const handleDeleteButton = (row) => {
    setAnnDetails(row.id);
    setModalShow(true);
  };

  const handleDeleteAndNavigate = async () => {
    if (anndetails) {
      try {
        const response = await schoolApi.deleteAnouncement(anndetails);
        toast.success(response.message);
        navigate("/announcements");
        fetchUpdatedAnouncement();
      } catch (error) {
        return toast.error(error.response.data.message);
      }
    }
    setModalShow(false);
  };

  const handleFileChange = (e) => {
    let files = Array.from(e.target.files);
    console.log('pawan file--->', files);

    files[0].url = URL.createObjectURL(files[0]);

    setSelectedFiles((previous) => [...previous, ...files]);

    let previews = files;

    setPreviewFiles((previous) => {
      const newFiles = previews.filter(
        (newFile) => !previous.some((file) => file.name === newFile.name)
      );

      return [...previous, ...newFiles];
    });
  };

  // Handle file removal
  const removeFile = (index) => {
    const newFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(newFiles);

    setPreviewFiles((previous) =>
      previous.filter((_, i) => i !== index)
    );
  };

  const header = [
    { title: "Title", prop: "title", isFilterable: true },
    { title: "Description", prop: "description", isFilterable: true },
    {
      title: "Action",
      prop: "",
      isFilterable: true,
      cell: (row) => (
        <div>
          <button
            className="btn btn-sm edit-button mx-1"
            onClick={() => handleEditButton(row)}
          >
            <i className="fa-regular fa-pen-to-square"></i>
          </button>
          <button
            className="btn btn-sm btn-danger mx-1"
            onClick={() => handleDeleteButton(row)}
          >
            <i className="fa-regular fa-trash-can"></i>
          </button>
        </div>
      ),
    },
  ];

  const labels = {
    beforeSelect: " ",
  };

  const handleShowModal = () => {
    setBtnName("Save");
    setAnnDetails({
      title: "",
      description: "",
      media: [],
    });
    setSelectedFiles([]);
    setPreviewFiles([]);
    setReportData((prevState) => ({
      ...prevState,
      date: "",
    }));
    setIsModal(true);
  };

  const handleCloseModal = () => {
    setIsModal(false);
    fetchUpdatedAnouncement();
  };

  const headerStyle = {
    backgroundColor: "lightblue",
  };

  const handleSave = async (e) => {
    if (anndetails.title === "" || anndetails.date === "") {
      toast.error("Missing required fields.");
      return;
    }

    try {

      if (btnName === "Update") {
        const updateAnouncement = await schoolApi.updateAnouncement(anndetails);
        if (updateAnouncement.success === true) {
          toast.success(updateAnouncement.message);
          navigate("/announcements");
          setIsModal(false);
          fetchUpdatedAnouncement();
        } else {
          return toast.error(updateAnouncement.message);
        }
      } else {


        const createdAnouncement = await schoolApi.createAnouncement(anndetails);

        console.log('createdAnouncement-->', createdAnouncement);
        if (createdAnouncement.success === true) {


          for (let i = 0; i < previewFiles.length; i++) {

            let formData = new FormData();

            formData.append(`files${i}`, previewFiles[i]);
            formData.append(`description`, fileDescription);

            console.log('formData-on handleSubmit->', formData);

            const fileResult = await schoolApi.createFile(
              createdAnouncement?.record?.id,
              formData
            );

            console.log('fileResult-->', fileResult);
          }

          setIsModal(false);
          toast.success(createdAnouncement.message);
          fetchUpdatedAnouncement();
        } else {
          return toast.error(createdAnouncement.message);
        }
      }
      setAnnDetails({
        title: "",
        description: "",
        media: [],
      });
      setSelectedFiles([]);
      setPreviewFiles([]);
    } catch (error) {
      return toast.error(error.response.data.message);
    }
  };

  const createAnouncement = () => {
    // if (
    //   canEdit ||
    //   userInfo?.userrole === "SYS_ADMIN" ||
    //   userInfo?.userrole === "ADMIN"
    // ) {
    navigate(`/createanouncement`);
    //}
  };


  console.log('anouncement details-->', anndetails);

  console.log('previewFiles-->', previewFiles);
  console.log('selectedFiles-->', selectedFiles);

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>

      {modalShow && (
        <Confirm
          show={modalShow}
          onHide={() => setModalShow(false)}
          handleDeleteButton={() => handleDeleteAndNavigate()}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="announcement"
        />
      )}
      <Col lg={2} className="mx-4">
        <Row>
          <Col lg={12}>
            <Link className="nav-link" to="/">
              Home <i className="fa-solid fa-chevron-right"></i> Announcements
            </Link>
          </Col>
        </Row>
      </Col>

      {successMessage && (
        <Alert
          variant="success"
          onClose={() => setSuccessMessage(null)}
          dismissible
        >
          {successMessage}
        </Alert>
      )}
      <Row className="g-0">
        <Col lg={12} className="px-lg-4">
          {body ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 15,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={3}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Filter />
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={5}
                  className="d-flex flex-col justify-content-start align-items-start"
                >
                  <PaginationOptions labels={labels} />
                  <div style={{ marginTop: "5px" }}>
                    <InfoPill left="Total Anouncements" right={body?.length} />
                  </div>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Button
                    className="btn-light add-new-button"
                    variant=""
                    onClick={() => createAnouncement(true)}
                  >
                    New Anouncement
                  </Button>
                </Col>
              </Row>
              <Table striped className="data-table">
                <TableHeader headerStyles={headerStyle} />
                <TableBody />
              </Table>
              <Pagination />
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Modal
          show={isModal}
          centered
          className="modal-dialog-scrollable"
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Header closeButton onClick={handleCloseModal}>
            <Modal.Title>Announcement</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {successMessage && (
              <div className="alert alert-success">{successMessage}</div>
            )}
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    disabled={true}
                    placeholder="Enter Title"
                    value={anndetails.title}
                    onChange={(e) =>
                      setAnnDetails({
                        ...anndetails,
                        title: e.target.value,
                      })
                    }
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            {/* <Row>
              <Col lg={12} className="mt-3">
                <Form.Group>
                  <Form.Label>Files</Form.Label>
                  <Form.Control
                    type="file"
                    multiple
                    disabled={true}
                    onChange={handleFileChange}
                    className="mb-2"
                  />
                  <div className="d-flex flex-wrap gap-2">
                    {previewFiles?.map((file, index) => (
                      <div key={index} className="file-preview d-flex align-items-center p-2 border rounded">
                        {file.type?.startsWith('image/') ? (
                          <img src={file.url} alt={file.name} style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
                        ) : (
                          <i className="fa-solid fa-file"></i>
                        )}
                        <span className="ms-2">{file.name}</span>
                        <button
                          type="button"
                          disabled={true}
                          className="btn btn-sm btn-danger ms-2"
                          onClick={() => removeFile(index)}
                        >
                          <i className="fa-solid fa-times"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                </Form.Group>
              </Col>
            </Row> */}

<Row>
  <Col lg={12}>
    <Form.Group className="mb-3">
      <Form.Label>Files</Form.Label>
      <Form.Control
        type="file"
        multiple
        onChange={handleFileChange}
        className="mb-2"
        disabled
        accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt"
      />
      <div className="d-flex flex-wrap gap-2">
        {previewFiles.map((file, index) => (
          <div key={index} className="file-preview d-flex align-items-center p-2 border rounded">
            {file.type.startsWith("image/") ? (
              <img src={file.url} alt={file.name} style={{ width: "50px", height: "50px", objectFit: "cover" }} />
            ) : file.type.startsWith("video/") ? (
              <video src={file.url} style={{ width: "50px", height: "50px", objectFit: "cover" }} />
            ) : file.type === "application/pdf" ? (
              <a href={file.url} disabled={true} className="text-decoration-none">
                <i disabled={true} readOnly={true} className="fa-solid fa-file-pdf text-danger"></i>
                 {/* {file.name} */}
              </a>
            ) : file.type.includes("word") || file.name.endsWith(".doc") || file.name.endsWith(".docx") ? (
              <i className="fa-solid fa-file-word text-primary"></i>
            ) : file.type.includes("spreadsheet") || file.name.endsWith(".xls") || file.name.endsWith(".xlsx") ? (
              <i className="fa-solid fa-file-excel text-success"></i>
            ) : file.name.endsWith(".csv") ? (
              <i className="fa-solid fa-file-csv text-info"></i>
            ) : file.name.endsWith(".txt") ? (
              <i className="fa-solid fa-file-lines text-secondary"></i>
            ) : (
              <i className="fa-solid fa-file"></i>
            )}
            <span className="ms-2">{file.name}</span>
            <button type="button" className="btn btn-sm btn-danger ms-2" disabled onClick={() => removeFile(index)}>
              <i className="fa-solid fa-times"></i>
            </button>
          </div>
        ))}
      </div>
    </Form.Group>
  </Col>
</Row>
            <Row>
              <Col lg={12} className="mt-3">
                <Form.Group>
                  <Form.Label>Description</Form.Label>
                  <EditorProvider className="resizable-editor">
                    <Editor
                      name="description"
                      disabled={true}
                      placeholder="Enter description"
                      onChange={(e) =>
                        setAnnDetails({
                          ...anndetails,
                          description: e.target.value,
                        })
                      }
                      value={anndetails.description}
                    >
                      {/* <Toolbar>
                      <BtnBold />
                      <BtnItalic />
                      <BtnAlignLeft />
                      <BtnAlignCenter />
                      <BtnAlignRight />
                      <BtnLi/>
                      <BtnUl/>
                    </Toolbar> */}
                    </Editor>
                  </EditorProvider>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <div className="text-right mt-4">
              <Button variant="light" onClick={handleCloseModal}>
                Close
              </Button>
            </div>
            <div className="text-right mt-4">
              <Button type="submit" disabled={true} variant="primary" onClick={handleSave}>
                {btnName}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
        />
        <Col lg={2}></Col>
      </Row>
    </>
  );
};

export default Anouncement;
